var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import SketchPicker from 'react-color/lib/components/sketch/Sketch';
import closechooserbutton from '../../../../images/icons/longreadeditor/closechooserbutton.svg';
import black from '../../../../images/icons/longreadeditor/colors/Black.svg';
import darkgray from '../../../../images/icons/longreadeditor/colors/DarkGray.svg';
import darkbrown from '../../../../images/icons/longreadeditor/colors/DarkBrown.svg';
import denimblue from '../../../../images/icons/longreadeditor/colors/DenimBlue.svg';
import dryyellow from '../../../../images/icons/longreadeditor/colors/DryYellow.svg';
import red from '../../../../images/icons/longreadeditor/colors/Red.svg';
import brickred from '../../../../images/icons/longreadeditor/colors/BrickRed.svg';
import pumporange from '../../../../images/icons/longreadeditor/colors/PumpkinOrange.svg';
import lemonjuiceyellow from '../../../../images/icons/longreadeditor/colors/LemonJuiceYellow.svg';
import whitechoosed from '../../../../images/icons/longreadeditor/colors/WhiteChoosed.svg';
import oldblue from '../../../../images/icons/longreadeditor/colors/OldBlue.svg';
import peagreen from '../../../../images/icons/longreadeditor/colors/PeaGreen.svg';
import imagebtn from '../../../../images/icons/ImageIcon.svg';
import CancelWhite from '../../../../images/icons/longreadeditor/updatepostcancelwhite.svg';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import changebg from '../../../../images/icons/changebg.svg';
import { colorObj } from '../../../../constants/colorObj';
import { paddings, heights } from '../../../../constants/paddings';
import ChooserIcon, { ColorElement } from '../../modules/buttons/choosericon';
import AddPostBtn from '../../modules/buttons/addpostbtn';
import UpdatePostBtn from '../../modules/buttons/updatepostbtn';
import CustomPicker from './CustomPicker/CustomPicker';
// const COLORS = [
//   '#FEFEFE',
//   '#2A3034',
//   '#2E2D2B',
//   '#4B3132',
//   '#C64839',
//   '#E36650',
//   '#E7894B',
//   '#F1DB63',
//   '#F2E4B3',
//   '#A4B54D',
//   '#96AAC1',
//   '#768488'
// ]
var COLORS = [
    '#1B242A',
    '#44697D',
    '#312626',
    '#FF0000',
    '#F9461C',
    '#EADF00',
    '#B9C9D0',
    '#69BE28',
    '#2526A9',
    '#0CC6DE',
    '#8C6CD0'
];
var COLORS_ABRIDGED = [
    '#1b242a',
    '#44697d',
    '#312626',
    '#ff0000',
    '#f9461c',
    '#eadf00',
    '#b9c9d0',
    '#69be28',
    '#2526a9',
    '#0cc6de',
    '#8c6cd0'
];
var UserColorChoose = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  //vertical-align: middle;\n  cursor: pointer;\n  margin-right: 16px;\n"], ["\n  position: relative;\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  //vertical-align: middle;\n  cursor: pointer;\n  margin-right: 16px;\n"])));
var UserColorChooseBlock = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: 15;\n  position: absolute;\n  left: -70px;\n  //top: 40px;\n  bottom: 40px;\n"], ["\n  z-index: 15;\n  position: absolute;\n  left: -70px;\n  //top: 40px;\n  bottom: 40px;\n"])));
var ChangeBgBtn = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  background: url(", ") no-repeat center;\n  cursor: pointer;\n  position: relative;\n  opacity: ", ";\n  //vertical-align: middle;\n"], ["\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  background: url(", ") no-repeat center;\n  cursor: pointer;\n  position: relative;\n  opacity: ", ";\n  //vertical-align: middle;\n"])), changebg, function (props) { return (props.disabled ? '0.2' : '1'); });
var PaletteWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  ", ";\n"])), function (_a) {
    var skipReducedVersion = _a.theme.skipReducedVersion;
    return skipReducedVersion
        ? null
        : css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: 948px;\n            display: none;\n          }\n        "], ["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: 948px;\n            display: none;\n          }\n        "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT);
});
export default function ColorMenuComp(props) {
    var color = props.color, closeChooser = props.closeChooser, chooseColor = props.chooseColor, bigimageRef = props.bigimageRef, addFile = props.addFile, clickedAction = props.clickedAction, isDisabled = props.isDisabled, style = props.style, canceledAction = props.canceledAction, postStyle = props.postStyle, src = props.src;
    var choosedColor = postStyle === 'big' ? '' : color;
    var savedCustomColor = localStorage.getItem('lastCustomColor');
    var initialColor = choosedColor || savedCustomColor || '#fff';
    var _a = useState(initialColor), usercolor = _a[0], setUserColor = _a[1];
    var _b = useState(false), picker = _b[0], togglePicker = _b[1];
    var ref = useRef(null);
    var buttonRef = useRef(null);
    var onChangeUserColor = function (color) {
        setUserColor(color);
        chooseColor(null, true, color);
    };
    var handleClickOutside = useCallback(function (event) {
        if (buttonRef.current && buttonRef.current.contains(event.target)) {
            togglePicker(!picker);
            return;
        }
        if (ref.current && !ref.current.contains(event.target)) {
            togglePicker(false);
        }
    }, [picker, ref, buttonRef]);
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);
    var colorList = useMemo(function () {
        return COLORS_ABRIDGED.map(function (color) {
            return (React.createElement(ColorElement, { key: color, color: color, selected: choosedColor === color, onClick: function () { return onChangeUserColor(color); } }));
        });
    }, [choosedColor, chooseColor]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PaletteWrapper, null),
        React.createElement(UserColorChoose, null,
            React.createElement(ChangeBgBtn, { ref: buttonRef }),
            picker ? (React.createElement(UserColorChooseBlock, { ref: ref },
                React.createElement(SketchPicker, { color: usercolor, presetColors: COLORS, onChangeComplete: function (color) { return onChangeUserColor(color.hex); }, disableAlpha: true }))) : (''))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=colormenu.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import SketchPicker from 'react-color/lib/components/sketch/Sketch';
import closechooserbutton from '../../../../images/icons/longreadeditor/closechooserbutton.svg';
import black from '../../../../images/icons/longreadeditor/colors/Black.svg';
import darkgray from '../../../../images/icons/longreadeditor/colors/DarkGray.svg';
import darkbrown from '../../../../images/icons/longreadeditor/colors/DarkBrown.svg';
import denimblue from '../../../../images/icons/longreadeditor/colors/DenimBlue.svg';
import dryyellow from '../../../../images/icons/longreadeditor/colors/DryYellow.svg';
import red from '../../../../images/icons/longreadeditor/colors/Red.svg';
import brickred from '../../../../images/icons/longreadeditor/colors/BrickRed.svg';
import pumporange from '../../../../images/icons/longreadeditor/colors/PumpkinOrange.svg';
import lemonjuiceyellow from '../../../../images/icons/longreadeditor/colors/LemonJuiceYellow.svg';
import whitechoosed from '../../../../images/icons/longreadeditor/colors/WhiteChoosed.svg';
import oldblue from '../../../../images/icons/longreadeditor/colors/OldBlue.svg';
import peagreen from '../../../../images/icons/longreadeditor/colors/PeaGreen.svg';
import imagebtn from '../../../../images/icons/ImageIcon.svg';
import CancelWhite from '../../../../images/icons/longreadeditor/updatepostcancelwhite.svg';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import changebg from '../../../../images/icons/changebg.svg';
import { colorObj } from '../../../../constants/colorObj';
import { paddings, heights } from '../../../../constants/paddings';
import ChooserIcon, { ColorElement } from '../../modules/buttons/choosericon';
import AddPostBtn from '../../modules/buttons/addpostbtn';
import UpdatePostBtn from '../../modules/buttons/updatepostbtn';
import CustomPicker from './CustomPicker/CustomPicker';
// const COLORS = [
//   '#FEFEFE',
//   '#2A3034',
//   '#2E2D2B',
//   '#4B3132',
//   '#C64839',
//   '#E36650',
//   '#E7894B',
//   '#F1DB63',
//   '#F2E4B3',
//   '#A4B54D',
//   '#96AAC1',
//   '#768488'
// ]
var COLORS = [
    '#1B242A',
    '#44697D',
    '#312626',
    '#FF0000',
    '#F9461C',
    '#EADF00',
    '#B9C9D0',
    '#69BE28',
    '#2526A9',
    '#0CC6DE',
    '#8C6CD0'
];
var COLORS_ABRIDGED = [
    '#1b242a',
    '#44697d',
    '#312626',
    '#ff0000',
    '#f9461c',
    '#eadf00',
    '#b9c9d0',
    '#69be28',
    '#2526a9',
    '#0cc6de',
    '#8c6cd0'
];
var UserColorChoose = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  //vertical-align: middle;\n  cursor: pointer;\n  margin-right: 16px;\n"], ["\n  position: relative;\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  //vertical-align: middle;\n  cursor: pointer;\n  margin-right: 16px;\n"])));
var UserColorChooseBlock = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: 15;\n  position: absolute;\n  left: -70px;\n  //top: 40px;\n  bottom: 40px;\n"], ["\n  z-index: 15;\n  position: absolute;\n  left: -70px;\n  //top: 40px;\n  bottom: 40px;\n"])));
var ChangeBgBtn = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  background: url(", ") no-repeat center;\n  cursor: pointer;\n  position: relative;\n  opacity: ", ";\n  //vertical-align: middle;\n"], ["\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  background: url(", ") no-repeat center;\n  cursor: pointer;\n  position: relative;\n  opacity: ", ";\n  //vertical-align: middle;\n"])), changebg, function (props) { return (props.disabled ? '0.2' : '1'); });
var PaletteWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  ", ";\n"])), function (_a) {
    var skipReducedVersion = _a.theme.skipReducedVersion;
    return skipReducedVersion
        ? null
        : css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: 948px;\n            display: none;\n          }\n        "], ["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: 948px;\n            display: none;\n          }\n        "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT);
});
export default function ColorMenuComp(props) {
    var color = props.color, closeChooser = props.closeChooser, chooseColor = props.chooseColor, bigimageRef = props.bigimageRef, addFile = props.addFile, clickedAction = props.clickedAction, isDisabled = props.isDisabled, style = props.style, canceledAction = props.canceledAction, postStyle = props.postStyle, src = props.src;
    var choosedColor = postStyle === 'big' ? '' : color;
    var savedCustomColor = localStorage.getItem('lastCustomColor');
    var initialColor = choosedColor || savedCustomColor || '#fff';
    var _a = useState(initialColor), usercolor = _a[0], setUserColor = _a[1];
    var _b = useState(false), picker = _b[0], togglePicker = _b[1];
    var ref = useRef(null);
    var buttonRef = useRef(null);
    var onChangeUserColor = function (color) {
        setUserColor(color);
        chooseColor(null, true, color);
    };
    var handleClickOutside = useCallback(function (event) {
        if (buttonRef.current && buttonRef.current.contains(event.target)) {
            togglePicker(!picker);
            return;
        }
        if (ref.current && !ref.current.contains(event.target)) {
            togglePicker(false);
        }
    }, [picker, ref, buttonRef]);
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);
    var colorList = useMemo(function () {
        return COLORS_ABRIDGED.map(function (color) {
            return (React.createElement(ColorElement, { key: color, color: color, selected: choosedColor === color, onClick: function () { return onChangeUserColor(color); } }));
        });
    }, [choosedColor, chooseColor]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PaletteWrapper, null),
        React.createElement(UserColorChoose, null,
            React.createElement(ChangeBgBtn, { ref: buttonRef }),
            picker ? (React.createElement(UserColorChooseBlock, { ref: ref },
                React.createElement(SketchPicker, { color: usercolor, presetColors: COLORS, onChangeComplete: function (color) { return onChangeUserColor(color.hex); }, disableAlpha: true }))) : (''))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=colormenu.js.map